import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { X, Lightbulb } from 'lucide-react';

const InfoPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const foodFacts = [
    {
      fact: "En este caso hablaremos acerca de los frijoles negros, los cuales se consideran un alimento saludable y funcional con buen valor nutritivo, ya que presentan un alto contenido de proteínas y un alto contenido de fibra dietética, así como fitatos, taninos y oligosacáridos no digeribles, además de tener más proteína, antioxidantes, fibra y minerales",
      source: "CIAD",
      sourceUrl: "https://www.ciad.mx/frijol-negro-un-alimento-accesible-nutritivo-y-antioxidante/"
    },
    {
      fact: "Los sustitutos del azúcar pueden ser útiles para las personas que están tratando de adelgazar. Le suministran el dulzor a los alimentos y las bebidas sin aportarles calorías extras. La mayoría de estos casi no contienen calorías.",
      source: "Medline Plus",
      sourceUrl: "https://medlineplus.gov/spanish/ency/article/007492.htm"
    },
    {
      fact: "El glutamato monosódico (GMS) es un ingrediente alimentario que suele tener mala prensa. Sin embargo, su impopularidad es infundada. El GMS puede utilizarse de forma segura para añadir sabor y lograr que la comida sea más apetitosa, e incluso se lo usa para reducir el nivel de sodio de los alimentos.Algunos alimentos que se usan a menudo por sus propiedades saborizantes, como los champiñones y los tomates, tienen altos niveles de glutamato natural.",
      source: "eufic",
      sourceUrl: "https://www.eufic.org/es/que-contienen-los-alimentos/articulo/que-es-el-glutamato-monosodico-es-perjudicial-para-la-salud"
    }
  ];

  const randomFact = foodFacts[Math.floor(Math.random() * foodFacts.length)];

  useEffect(() => {
    const lastShown = localStorage.getItem('foodtrack_tip_shown');
    const today = new Date().toDateString();

    if (lastShown !== today) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        localStorage.setItem('foodtrack_tip_shown', today);
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md animate-scale-in">
        <DialogHeader className="text-left">
          <div className="flex items-center gap-2 mb-3">
            <div className="p-2 bg-amber-100 rounded-full">
              <Lightbulb className="h-5 w-5 text-amber-600" />
            </div>
            <DialogTitle className="text-lg font-semibold text-foreground">
              ¿Sabías que...?
            </DialogTitle>
          </div>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-muted-foreground leading-relaxed">
            {randomFact.fact}
          </p>

          <div className="pt-2 border-t">
            <p className="text-xs text-muted-foreground">
              Source: {" "}
              <a
                href={randomFact.sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                {randomFact.source}
              </a>
            </p>
          </div>

          <div className="flex justify-between items-center pt-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                setIsOpen(false);
                navigate('/food-facts');
              }}
              className="text-primary hover:text-primary/80"
            >
              Ver todos los datos curiosos
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setIsOpen(false)}
            >
              ¡Entendido!
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InfoPopup;